import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-home-browser-support-modal',
  templateUrl: './home-browser-support-modal.component.html',
  styleUrls: ['./home-browser-support-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBrowserSupportModalComponent {
  constructor(public dialogRef: MatDialogRef<HomeBrowserSupportModalComponent>) {}

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}
